import { c as _c } from "react/compiler-runtime";
import type { WebhookPortalResponse } from '@onefootprint/request-types/dashboard';
import dynamic from 'next/dynamic';
import { useTheme } from 'next-themes';
export type ContentProps = {
  data: WebhookPortalResponse;
};
const Content = t0 => {
  const $ = _c(3);
  const {
    data
  } = t0;
  const {
    theme
  } = useTheme();
  const t1 = theme === "dark";
  let t2;
  if ($[0] !== data.url || $[1] !== t1) {
    t2 = <AppPortal darkMode={t1} fontFamily="Inter" fullSize={true} url={data.url} />;
    $[0] = data.url;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
const AppPortal = dynamic({
  loader: () => import('svix-react').then(mod => mod.AppPortal)
}, {
  ssr: false
});
export default Content;